import React, { PureComponent } from 'react';
import { defaultMemoize } from 'reselect';
import sortBy from 'lodash/sortBy';
import { Form, FormGroup, FormError } from '../../../components/Forms/Forms';
import { Input, Select } from '../../../components/Forms/fields/index';
import rules from '../../../components/Forms/rules';
import Auth from '../../../libs/Auth';
import { USD } from '../../../libs/formatter';
import Modal from '../../../components/Modal';
import config from '../../../../../config';
import enums from '../../../constants/enums';
import LinkedAccountModal from './LinkedAccountModal';

class DataView extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      editDataEnabled: false,
      sort: {
        active: {
          column: 'rank',
          reverse: false,
        },
        deactivated: {
          column: 'name',
          reverse: false,
        },
        accounts: {
          column: 'index',
          reverse: false,
        }
      },
    };
    this.sortedItems = {
      active: defaultMemoize(this.sortedItems),
      deactivated: defaultMemoize(this.sortedItems),
      accounts: defaultMemoize(this.sortedItems),
    };
  }

  sortedItems(items, sortConfig, balanceSellingAccountsMap) {
    if (!items) {
      return items;
    }
    let result = items;
    if (balanceSellingAccountsMap) {
      result = result.map((item) => {
        if (balanceSellingAccountsMap[item.value]) {
          return {
            ...item,
            balanceSellingAccount: balanceSellingAccountsMap[item.value],
            isLinked: !!balanceSellingAccountsMap[item.value],
            isActiveLinked: balanceSellingAccountsMap[item.value] && balanceSellingAccountsMap[item.value].active,
            primeExternal: balanceSellingAccountsMap[item.value] && balanceSellingAccountsMap[item.value].prime,
          };
        }
        return item;
      });
    }
    result = sortBy(result, sortConfig.column);
    if (sortConfig.reverse) {
      result = result.reverse();
    }

    return result;
  }

  sort(column, key) {
    const sortConfig = this.state.sort[key];
    if (sortConfig.column === column) {
      this.setState({
        sort: {
          ...this.state.sort,
          [key]: {
            ...sortConfig,
            reverse: !sortConfig.reverse,
          },
        },
      });
    } else {
      this.setState({
        sort: {
          ...this.state.sort,
          [key]: {
            column,
            reverse: false,
          },
        },
      });
    }
  }

  renderAmazonBalances(unsortedBalances, key, updateSellBalance = () => {}) {
    const amazonBalances = this.sortedItems[key](unsortedBalances, this.state.sort[key]);
    return (
      <div>
        {amazonBalances && (
          <table className="amazonBalances">
            <thead>
              <tr>
                <th className="sortable" onClick={() => this.sort('rank', key)}>Rank</th>
                <th className="sortable" onClick={() => this.sort('name', key)}>Account Name</th>
                <th className="sortable" onClick={() => this.sort('value', key)}>Email</th>
                <th className="sortable" onClick={() => this.sort('balance', key)}>Balance</th>
                <th className="sortable" onClick={() => this.sort('sellBalance', key)}>Sell Balance</th>
                <th className="sortable" onClick={() => this.sort('redeemedDay', key)}>day</th>
                <th className="sortable" onClick={() => this.sort('redeemed2Day', key)}>2 day</th>
                <th className="sortable" onClick={() => this.sort('redeemed3Day', key)}>3 day</th>
                <th className="sortable" onClick={() => this.sort('redeemedWeek', key)}>week</th>
                <th className="sortable" onClick={() => this.sort('redeemedMonth', key)}>month</th>
                <th className="sortable" onClick={() => this.sort('redeemedYear', key)}>year</th>
                <th className="sortable" onClick={() => this.sort('timestamp', key)}>Last Updated</th>
                {config.showStrategy && (
                  <th className="sortable" onClick={() => this.sort('strategy', key)}>Strategy</th>
                )}
                {config.showStrategy && (
                  <th className="sortable" onClick={() => this.sort('buy', key)}>Buy</th>
                )}
                {config.showStrategy && (
                  <th className="sortable" onClick={() => this.sort('prime', key)}>Prime</th>
                )}
                {config.features.balanceSelling && (
                  <th className="sortable" onClick={() => this.sort('primeExternal', key)}>Prime External</th>
                )}
              </tr>
            </thead>
            <tbody>
              {amazonBalances.map((amazonBalance, i) => (
                <tr key={i}>
                  <td>{amazonBalance.rank}</td>
                  <td>{amazonBalance.originalLabel}</td>
                  <td>{amazonBalance.value}</td>
                  <td>{USD(amazonBalance.balance)}</td>
                  <td>{amazonBalance.balanceAccount ? (
                    <div>
                      {!amazonBalance.balanceMatches ? (
                        <a
                          title="click to check balance"
                          onClick={(e) => {
                            e.preventDefault();
                            updateSellBalance(amazonBalance.balanceAccount.id);
                          }}
                          style={{color: 'red'}}
                        >
                          {USD(amazonBalance.sellBalance)}
                        </a>
                      ) : (
                        USD(amazonBalance.sellBalance)
                      )}
                    </div>
                  ) : null}</td>
                  <td>{USD(amazonBalance.redeemedDay)}</td>
                  <td>{USD(amazonBalance.redeemed2Day)}</td>
                  <td>{USD(amazonBalance.redeemed3Day)}</td>
                  <td>{USD(amazonBalance.redeemedWeek)}</td>
                  <td>{USD(amazonBalance.redeemedMonth)}</td>
                  <td>{USD(amazonBalance.redeemedYear)}</td>
                  <td>{(new Date(amazonBalance.timestamp)).toLocaleString()}</td>
                  {config.showStrategy && (
                    <td>{amazonBalance.strategy}</td>
                  )}
                  {config.showStrategy && (
                    <td>{amazonBalance.buy}</td>
                  )}
                  {config.showStrategy && (
                    <td>{amazonBalance.prime && 'yes'}</td>
                  )}
                  {config.features.balanceSelling && (
                    <td>
                      {amazonBalance.balanceAccount && (
                        <div>
                          {amazonBalance.primeExternal === true && 'Yes'}
                          {amazonBalance.primeExternal === false && 'No'}
                          {typeof amazonBalance.primeExternal !== 'boolean' && 'Unset'}
                        </div>
                      )}
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
            <tbody>
              <tr>
                <td colSpan="8">Total Balance: {USD(amazonBalances.reduce((total, balance) => total + balance.balance, 0))}</td>
              </tr>
            </tbody>
          </table>
        )}
      </div>
    );
  }
  render() {
    const {
      formState,
      onFormUpdate,
      submitForm,
      removeItem,
      hardRemoveItem,
      addItem,
      rankedAccounts,
      toggleSection,
      sections,
      showBrowserConfig,
      browserConfig,
      toggleBrowserConfig,
      showDeleted,
      toggleShowDeleted,
      openAddFromCSV,
      showAddFromCSV,
      onCSVSelected,
      addFromCSV,
      balanceSellingAccountsMap,
      editLinkedAccount,
      linkAccount,
      toggleLinkedAccount,
      toggleLinkedAccountPrime,
      csvValidationErrors,
      showLinkedAccountModal,
      deleteBalanceSellingAccount,
      updateSellBalance,
      csvData,
      maxPerDay,
      setMaxPerDay,
      saveMaxPerDay,
    } = this.props;

    const { editDataEnabled } = this.state;

    const amazonAccounts = this.sortedItems.accounts(formState.data.amazonAccounts, this.state.sort.accounts, balanceSellingAccountsMap);

    let totalBalance = 0;
    let totalBalanceOverFive = 0;
    if (rankedAccounts) {
      totalBalance = USD(rankedAccounts.reduce((total, balance) => total + (balance.balance || 0), 0));
      totalBalanceOverFive = USD(rankedAccounts.reduce((total, balance) => total + (balance.balance > 5 ? balance.balance : 0), 0));
    }

    return (
      <div className="dynamic-data-page">
        <h1>Dynamic data</h1>

        {config.proxyBrowserEnabled && (
          <div className="proxy-browser-download">
            Download the proxy browser from <a href={config.proxyBrowserDownloadPage}>here</a>. Use the credentials of an amazonPlugin user type.
            Your API URL is <strong>{config.api.default}</strong>
          </div>
        )}

        <p></p>
        <div className="max-per-day" style={{ display: 'flex', width: 500 }} >
          <label style={{ width: 140, lineHeight: '38px' }}>Max Per Day:</label>
          <input type="text" value={maxPerDay} onChange={e => setMaxPerDay(e.target.value)}/>
          <button type="button" className="button" onClick={saveMaxPerDay}>save</button>
        </div>

        <h2 className="toggler" onClick={() => toggleSection('balances', !sections.balances)}>
          {sections.balances ? '-' : '+'}
          Amazon Balances {totalBalanceOverFive} ({totalBalance})
        </h2>

        {sections.balances && (
          <div className="subscection">
            <div>
              {rankedAccounts && this.renderAmazonBalances(rankedAccounts, 'active', updateSellBalance)}
            </div>
          </div>
        )}


        {Auth.isType(['admin']) && (
          <div className="dynamic-data-container">
            <h2 className="toggler" onClick={() => toggleSection('accounts', !sections.accounts)}>
              {sections.accounts ? '-' : '+'}
              Amazon Accounts
            </h2>
            {sections.accounts && (
              <div className="subscection">
                <Form state={formState} onSubmit={submitForm} onChange={onFormUpdate}>
                  <div className="actions data-table-actions">
                    <button type="submit" className="button" disabled={!editDataEnabled}>Save</button>
                    <button
                      type="button"
                      disabled={!editDataEnabled}
                      className="button"
                      onClick={() => {
                        addItem({
                          key: 'amazonAccounts',
                          value: {
                            value: '',
                            label: '',
                            deactivated: false,
                          }
                        });
                      }}
                    >
                      + Account
                    </button>
                    <button
                      type="button"
                      className="button"
                      onClick={() => {
                        toggleBrowserConfig({
                          show: true,
                        });
                      }}
                    >
                      Browser Config
                    </button>
                    <button
                      type="button"
                      className="button"
                      onClick={() => openAddFromCSV(true)}
                    >
                      Add from CSV
                    </button>
                    <button
                      type="button"
                      className="button warning"
                      onClick={() => this.setState({ editDataEnabled: !editDataEnabled })}
                    >
                      Toggle Edit Mode to {editDataEnabled ? 'OFF' : 'ON' }
                    </button>
                    <span>
                      <input
                        id="show-deleted-checkbox"
                        type="checkbox"
                        checked={showDeleted}
                        onChange={(() => toggleShowDeleted())}
                      />
                      <label htmlFor="show-deleted-checkbox">
                        Show Deleted
                      </label>

                    </span>
                  </div>
                  <table className="data-page-accounts-table">
                    <thead>
                      <tr>
                        <th className="sortable" onClick={() => this.sort('value', 'accounts')}>Email</th>
                        <th className="sortable" onClick={() => this.sort('label', 'accounts')}>Label</th>
                        {/* <th className="sortable" onClick={() => this.sort('accountName', 'accounts')}>Balance Name</th>*/}
                        <th className="sortable" onClick={() => this.sort('password', 'accounts')}>Password</th>
                        <th className="sortable" onClick={() => this.sort('proxy', 'accounts')}>Proxy</th>
                        <th className="sortable" onClick={() => this.sort('twoFactorCode', 'accounts')}>2FA</th>
                        <th className="sortable" onClick={() => this.sort('userAgent', 'accounts')}>User Agent</th>
                        {config.showStrategy && (
                          <th className="sortable" onClick={() => this.sort('strategy', 'accounts')}>Strategy</th>
                        )}
                        {config.showStrategy && (
                          <th className="sortable" onClick={() => this.sort('prime', 'accounts')}>Prime</th>
                        )}
                        {config.features.balanceSelling && (
                          <th className="sortable" onClick={() => this.sort('primeExternal', 'accounts')}>Prime Ext</th>
                        )}
                        {config.showStrategy && (
                          <th className="sortable" onClick={() => this.sort('buy', 'accounts')}>Buy</th>
                        )}
                        <th className="sortable" onClick={() => this.sort('prioritize', 'accounts')}>Prioritize</th>
                        <th className="sortable" onClick={() => this.sort('deactivated', 'accounts')}>Deactivated</th>
                        <th className="sortable" onClick={() => this.sort('external', 'accounts')}>External</th>
                        <th className="sortable" onClick={() => this.sort('parseBalance', 'accounts')}>Balance</th>
                        <th className="sortable" onClick={() => this.sort('autoDisabled', 'accounts')}>Auto Disabled</th>
                        <th className="sortable" onClick={() => this.sort('manual', 'accounts')}>Manual</th>
                        {config.features.balanceSelling && (
                          <th className="sortable" onClick={() => this.sort('isLinked', 'accounts')}>Balance Selling</th>
                        )}
                        {config.features.balanceSelling && (
                          <th className="sortable" onClick={() => this.sort('isActiveLinked', 'accounts')}>Balance Selling Active</th>
                        )}
                        <th className="sortable" onClick={() => this.sort('isDeleted', 'accounts')}>x</th>
                      </tr>
                    </thead>
                    <tbody>
                      {amazonAccounts.filter(account => showDeleted || !account.isDeleted).map((account) => {
                        const i = account.index;
                        const priceyakMissing2fa = account.isLinked && !account.balanceSellingAccount.totp_secret && account.twoFactorCode && account.twoFactorCode.trim();
                        return (
                          <tr key={i}>
                            <td>
                              {!editDataEnabled ? (
                                <span className="no-edit-data-item" >{account.value}</span>
                              ) : (
                                <FormGroup>
                                  <Input debounce disabled={account.isDeleted} type="text" name={`amazonAccounts[${i}].value`} validate={[rules.required()]}/>
                                  <FormError/>
                                </FormGroup>
                              )}
                            </td>
                            <td>
                              {!editDataEnabled ? (
                                <span className="no-edit-data-item" >{account.label}</span>
                              ) : (
                                <FormGroup>
                                  <Input debounce disabled={account.isDeleted} type="text" name={`amazonAccounts[${i}].label`} validate={[rules.required()]}/>
                                  <FormError/>
                                </FormGroup>
                              )}
                            </td>
                            <td>
                              {!editDataEnabled ? (
                                <span className="no-edit-data-item" >{account.password}</span>
                              ) : (
                                <FormGroup>
                                  <Input debounce disabled={account.isDeleted} type="text" name={`amazonAccounts[${i}].password`} />
                                  <FormError/>
                                </FormGroup>
                              )}
                            </td>
                            <td>
                              {!editDataEnabled ? (
                                <span className="no-edit-data-item" >{account.proxy}</span>
                              ) : (
                                <FormGroup>
                                  <Input debounce disabled={account.isDeleted} type="text" name={`amazonAccounts[${i}].proxy`} />
                                  <FormError/>
                                </FormGroup>
                              )}
                            </td>
                            <td
                              className={priceyakMissing2fa ? 'missing-2fa' : ''}
                              title={priceyakMissing2fa ? 'Balance selling account does not have 2fa saved. Please click edit and then save to make sure the 2fa is setup on the account properly' : ''}
                            >
                              {!editDataEnabled ? (
                                <span className="no-edit-data-item" style={{ width: 200 }} title={account.twoFactorCode}>{account.twoFactorCode}</span>
                              ) : (
                                <FormGroup>
                                  <Input debounce disabled={account.isDeleted} type="text" name={`amazonAccounts[${i}].twoFactorCode`} />
                                  <FormError/>
                                </FormGroup>
                              )}

                            </td>
                            <td>
                              {!editDataEnabled ? (
                                <span className="no-edit-data-item" >{account.userAgent}</span>
                              ) : (
                                <FormGroup>
                                  <Input debounce disabled={account.isDeleted} type="text" name={`amazonAccounts[${i}].userAgent`} />
                                  <FormError/>
                                </FormGroup>
                              )}
                            </td>
                            {config.showStrategy && (
                              <td>
                                {!editDataEnabled ? (
                                <span className="no-edit-data-item" >{account.strategy}</span>
                                ) : (
                                  <FormGroup>
                                    <Select debounce disabled={account.isDeleted} options={enums.accountStrategies} name={`amazonAccounts[${i}].strategy`} />
                                    <FormError/>
                                  </FormGroup>
                                )}
                              </td>
                            )}
                            {config.showStrategy && (
                              <td>
                                {!editDataEnabled ? (
                                <span className="no-edit-data-item" >{account.prime ? 'Yes' : ''}</span>
                                ) : (
                                  <FormGroup>
                                    <Input debounce disabled={account.isDeleted} type="checkbox" name={`amazonAccounts[${i}].prime`}/>
                                    <FormError/>
                                  </FormGroup>
                                )}
                              </td>
                            )}
                            {config.features.balanceSelling && (
                              <td>
                                {account.isLinked && (
                                  <div>
                                    {account.balanceSellingAccount.prime === true && 'Yes'}
                                    {account.balanceSellingAccount.prime === false && 'No'}
                                    {typeof account.balanceSellingAccount.prime !== 'boolean' && 'Unset'}
                                  </div>
                                )}
                              </td>
                            )}
                            {config.showStrategy && (
                              <td>
                                {!editDataEnabled ? (
                                <span className="no-edit-data-item" >{account.buy}</span>
                                ) : (
                                  <FormGroup>
                                    <Select debounce disabled={account.isDeleted} options={enums.accountBuyStrategies} name={`amazonAccounts[${i}].buy`} />
                                    <FormError/>
                                  </FormGroup>
                                )}
                              </td>
                            )}
                            <td>
                              {!editDataEnabled ? (
                                <span className="no-edit-data-item" >{account.prioritize ? 'Yes' : ''}</span>
                              ) : (
                                <FormGroup>
                                  <Input debounce disabled={account.isDeleted} type="checkbox" name={`amazonAccounts[${i}].prioritize`}/>
                                  <FormError/>
                                </FormGroup>
                              )}
                            </td>
                            <td>
                              {!editDataEnabled ? (
                                <span className="no-edit-data-item" >{account.deactivated ? 'Yes' : ''}</span>
                              ) : (
                                <FormGroup>
                                  <Input debounce disabled={account.isDeleted} type="checkbox" name={`amazonAccounts[${i}].deactivated`}/>
                                  <FormError/>
                                </FormGroup>
                              )}
                            </td>
                            <td>
                              {!editDataEnabled ? (
                                <span className="no-edit-data-item" >{account.external ? 'Yes' : ''}</span>
                              ) : (
                                <FormGroup>
                                  <Input debounce disabled={account.isDeleted} type="checkbox" name={`amazonAccounts[${i}].external`}/>
                                  <FormError/>
                                </FormGroup>
                              )}
                            </td>
                            <td>
                              {!editDataEnabled ? (
                                <span className="no-edit-data-item" >{account.parseBalance ? 'Yes' : ''}</span>
                              ) : (
                                <FormGroup>
                                  <Input debounce disabled={account.isDeleted} type="checkbox" name={`amazonAccounts[${i}].parseBalance`}/>
                                  <FormError/>
                                </FormGroup>
                              )}
                            </td>
                            <td>
                              {!editDataEnabled ? (
                                <span className="no-edit-data-item" >{account.autoDisabled ? 'Yes' : ''}</span>
                              ) : (
                                <FormGroup>
                                  <Input debounce disabled={account.isDeleted || !account.autoDisabled} type="checkbox" name={`amazonAccounts[${i}].autoDisabled`}/>
                                  <FormError/>
                                </FormGroup>
                              )}
                            </td>
                            <td>
                              {!editDataEnabled ? (
                                <span className="no-edit-data-item" >{account.manual ? 'Yes' : ''}</span>
                              ) : (
                                <FormGroup>
                                  <Input debounce type="checkbox" name={`amazonAccounts[${i}].manual`}/>
                                  <FormError/>
                                </FormGroup>
                              )}
                            </td>
                            {config.features.balanceSelling && (
                              <td>
                                {account.isLinked ? (
                                  <div>
                                    <a
                                      onClick={(e) => {
                                        e.preventDefault();
                                        editLinkedAccount(account);
                                      }}
                                    >edit</a>
                                    &nbsp;
                                    -
                                    &nbsp;
                                    <a
                                      onClick={(e) => {
                                        e.preventDefault();
                                        if (confirm('Are you sure you want to archive this account?')) {
                                          deleteBalanceSellingAccount(account.balanceSellingAccount.id);
                                        }
                                      }}
                                    >archive</a>
                                    &nbsp;
                                    -
                                    &nbsp;
                                    <a
                                      onClick={(e) => {
                                        e.preventDefault();
                                        if (confirm(`Are you sure you want to ${account.balanceSellingAccount.prime ? 'disable' : 'enable'} prime?`)) {
                                          toggleLinkedAccountPrime(account);
                                        }
                                      }}
                                    >{account.balanceSellingAccount.prime ? 'prime(x)' : 'prime(+)'}</a>
                                  </div>
                                ) : (
                                  <div>
                                    <a
                                      onClick={(e) => {
                                        e.preventDefault();
                                        linkAccount(account);
                                      }}
                                    >link</a>
                                  </div>
                                )}
                              </td>
                            )}
                            {config.features.balanceSelling && (
                              <td>
                                {account.isLinked && (
                                  <a
                                    onClick={(e) => {
                                      e.preventDefault();
                                      toggleLinkedAccount(account);
                                    }}
                                  >{account.isActiveLinked ? 'disable' : 'activate'}</a>
                                )}
                              </td>
                            )}
                            <td>
                              {account.isDeleted ? (
                                <div>
                                  <button
                                    className="button success"
                                    type="button"
                                    onClick={() => {
                                      removeItem({
                                        key: 'amazonAccounts',
                                        index: i,
                                        id: account.id,
                                        restore: true,
                                      });
                                    }}
                                  >
                                    +
                                  </button>

                                  <button
                                    title="Remove forever"
                                    className="button alert"
                                    type="button"
                                    onClick={() => {
                                      if (confirm('Are you sure you want to permanently remove this account')) {
                                        hardRemoveItem({
                                          key: 'amazonAccounts',
                                          index: i,
                                          id: account.id,
                                        });
                                      }
                                    }}
                                  >
                                    x
                                  </button>
                                </div>
                            ) : (
                              <button
                                className="button warning"
                                type="button"
                                onClick={() => {
                                  removeItem({
                                    key: 'amazonAccounts',
                                    index: i,
                                    id: account.id,
                                  });
                                }}
                              >
                                -
                              </button>
                            )}

                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </Form>
              </div>
            )}
          </div>
        )}
        {showLinkedAccountModal && (
          <LinkedAccountModal
            {...this.props}
          />
        )}
        {showBrowserConfig && (
          <Modal
            className={'modal-container browser-config-modal'}
            active
            onClose={() => toggleBrowserConfig({ show: false })}
          >
            <textarea name="jsonData" style={{ width: '100%', height: '100%' }} defaultValue={browserConfig}/>
          </Modal>
        )}
        {showAddFromCSV && (
          <Modal
            className={'modal-container add-from-csv-modal'}
            active
            onClose={() => openAddFromCSV(false)}
          >
            add from csv

            <div className="actions">
              <div>
                <input type="file" accept=".csv" onChange={onCSVSelected} />
              </div>
              {csvValidationErrors && (
                <div>
                  <h3>Errors</h3>
                  <ul>
                    {csvValidationErrors.map((error, i) => (
                      <li key={i}>{error}</li>
                    ))}
                  </ul>
                </div>
              )}
              <button
                disabled={!csvData || (csvValidationErrors && csvValidationErrors.length)}
                className="button"
                onClick={addFromCSV}
              >
                Add
              </button>
            </div>
          </Modal>
        )}
      </div>
    );
  }
}

export default DataView;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Data/Data.view.js